import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import { headersWithAuthWithoutBody } from "../APIHelpers/Responses";

export const reviewChecklistMetaServices = {
  getReviewChecklistData,
};

async function getReviewChecklistData(status, moduleType, searchData, page, length) {
  const query = new URLSearchParams();
  query.append("search", searchData || "");
  if (moduleType) query.append("moduleType", moduleType);
  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  const response = await fetch(
    `${config.API_URL}getReviewChecklistData/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );

  const data = await response.json();
  return data;
}
